import { createFileRoute } from "@tanstack/react-router";
import ExamPreparationGuideFr from "@/pages/resources/fr/ExamPreparationGuideFr";

export const Route = createFileRoute("/fr/learn/exam-preparation")({
  head: () => ({
    meta: [
        {
            "title": "Préparation aux examens : guide stratégique complet | System Atlas"
        },
        {
            "name": "description",
            "content": "Préparez vos examens avec des stratégies prouvées. De la planification aux techniques le jour J."
        },
        {
            "property": "og:title",
            "content": "Préparation aux examens : guide stratégique complet | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Préparez vos examens avec des stratégies prouvées. De la planification aux techniques le jour J."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/fr/learn/exam-preparation"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Préparation aux examens : guide stratégique complet | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Préparez vos examens avec des stratégies prouvées. De la planification aux techniques le jour J."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/fr/learn/exam-preparation"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/exam-preparation"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/exam-preparation"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/exam-preparation"
        }
    ],
  }),
  component: ExamPreparationGuideFr,
});
